import React from 'react';

import { TextStyledLink } from '@components/Common';
import { TextGroupProps } from '@components/TextGroups/interfaces';

import { renderParagraph } from '@utils/helpers';

import { PageHeader, Text, TextGroupContainer } from './styles';

/**
 * Text group component that display header, description and optional link.
 * Used in auth pages. and others components
 */

export const TextGroup = ({ href, header, paragraph, linkLabel, listing = false }: TextGroupProps) => (
  <TextGroupContainer>
    <PageHeader $listing={listing}>{header}</PageHeader>
    <Text>
      {renderParagraph(paragraph)}
      {href && <TextStyledLink href={href}>{linkLabel}</TextStyledLink>}
    </Text>
  </TextGroupContainer>
);
